/* eslint-disable react-hooks/rules-of-hooks */
import React, {
  createContext,
  FC,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

import BySecurity from '@/components/NewSecurity';
import { getRiskStrategyApi } from '@/services/security';

interface IGlobalContext {
  [key: string]: any;
}
interface IGlobalProvider {
  children: React.ReactElement | React.ReactElement[];
}

const globalContext = createContext<IGlobalContext>({});

const Provider = globalContext.Provider;
globalContext.displayName = 'securityProvider';

export const SecurityProvider: FC<IGlobalProvider> = ({ children }) => {
  const [securityKey, setSecurityKey] = useState<string>();
  const [riskToken, setRiskToken] = useState<string>();
  const [passToken, setPassToken] = useState<string>();
  const [email_verify_token, setEmailVerifyToken] = useState<string>();

  const getRiskTokenAjax = useCallback(async () => {
    if (securityKey) {
      const res = (await getRiskStrategyApi({
        sence: securityKey,
        ext_info_str: JSON.stringify({ email_verify_token }),
      })) as any;

      if (res?.result?.risk_token_type === 'pass') {
        setSecurityKey(undefined);
        setPassToken(res?.result?.risk_token);
        return;
      }

      setSecurityKey(undefined);
      setRiskToken(res?.result?.risk_token);
    }
  }, [email_verify_token, securityKey]);

  useEffect(() => {
    if (securityKey) {
      getRiskTokenAjax();
    }
    return () => {
      /** */
    };
  }, [securityKey, getRiskTokenAjax]);

  return (
    <Provider
      value={{
        passToken,
        setPassToken,
        setSecurityKey,
        setEmailVerifyToken,
      }}
    >
      {children}
      {riskToken && (
        <BySecurity
          key={riskToken}
          faceFailHandler={() => {
            setRiskToken(undefined);
            setEmailVerifyToken(undefined);
            setSecurityKey(undefined);
            setPassToken(undefined);
          }}
          risk_token={riskToken}
          clearTokenHandler={() => {
            setRiskToken(undefined);
            setEmailVerifyToken(undefined);
            setSecurityKey(undefined);
          }}
          callBack={(res: any) => {
            setPassToken(res?.result?.risk_token);
            setEmailVerifyToken(undefined);
            setSecurityKey(undefined);
            setRiskToken(undefined);
          }}
        />
      )}
    </Provider>
  );
};

export function useSecurityStore() {
  return useContext(globalContext);
}
